/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Billing_SubtitleInputs */



/**
* | output |
* | --- |
* | "What each customer was billed, month by month. Open a bill to see how it was calculated." |
*
* @param {Partner_Billing_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_subtitle = /** @type {((inputs?: Partner_Billing_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Was jedem Kunden berechnet wurde, Monat für Monat. Öffnen Sie eine Abrechnung, um zu sehen, wie sie berechnet wurde.")
	return /** @type {LocalizedString} */ ("What each customer was billed, month by month. Open a bill to see how it was calculated.")
});